var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 6C29.9249 6 25 7.84203 25 10.1143V39.8857C25 42.158 29.9249 44 36 44C42.0751 44 47 42.158 47 39.8857V10.1143C47 7.84203 42.0751 6 36 6Z",
    fill: "#F2CA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 33.3164C47 35.619 42.0751 37.4855 36 37.4855C29.9249 37.4855 25 35.619 25 33.3164",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 25.7168C47 27.4197 42.0751 28.8002 36 28.8002C29.9249 28.8002 25 27.4197 25 25.7168",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 18.1172C47 19.8201 42.0751 21.2006 36 21.2006C29.9249 21.2006 25 19.8201 25 18.1172",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10.5156C47 12.2186 42.0751 13.5991 36 13.5991C29.9249 13.5991 25 12.2186 25 10.5156",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.2852C7.92487 22.2852 3 24.1517 3 26.4543V39.8303C3 42.1329 7.92487 43.9994 14 43.9994C20.0751 43.9994 25 42.1329 25 39.8303V26.4543C25 24.1517 20.0751 22.2852 14 22.2852Z",
    stroke: "#383434"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33.3164C25 35.619 20.0751 37.4855 14 37.4855C7.92487 37.4855 3 35.619 3 33.3164",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.7168C25 27.4197 20.0751 28.8002 14 28.8002C7.92487 28.8002 3 27.4197 3 25.7168",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountIcon);
export default __webpack_public_path__ + "static/media/amountIcon.5a024086a631c4d1582314f83d940ca2.svg";
export { ForwardRef as ReactComponent };